<xpo-shell>
  <xpo-header-app-name>{{ title }}</xpo-header-app-name>
  <xpo-header-sub-app-name>{{ build }}</xpo-header-sub-app-name>
  <xpo-header-navigation>
    <ng-container *ngIf="isUserMaintAdmin$ | async">
      <button [routerLink]="apiComponentRoute" routerLinkActive="xpo-selected">Contracts</button>
      <button [routerLink]="componentOwnershipRoute" routerLinkActive="xpo-selected">Component Ownership</button>
      <button [routerLink]="aemRoute" routerLinkActive="xpo-selected">Exception Messages</button>
    </ng-container>
    <ng-container *ngIf="isUserEnsemble$ | async">
      <button [routerLink]="ensembleConfigRoute" routerLinkActive="xpo-selected">Ensemble Configs</button>
    </ng-container>
  </xpo-header-navigation>
  <xpo-header-actions>
    <xpo-auth-user-profile></xpo-auth-user-profile>
  </xpo-header-actions>
  <div class="content">
    <div class="app-Container-pre-content">
      <app-breadcrumbs></app-breadcrumbs>
      <app-helper-menu class="app-Container-pre-content-help-icon"></app-helper-menu>
    </div>
    <router-outlet></router-outlet>
  </div>
</xpo-shell>
<xpo-app-notification></xpo-app-notification>
